// Czech translations, keyed by the English source string. Missing keys fall back to
// English (the key itself), so coverage can grow incrementally (§20 i18n cs/en).
export const cs: Record<string, string> = {
  // Personal vault
  "Personal vault": "Osobní trezor",
  PERSONAL: "OSOBNÍ",
  // Secret health (M5.1)
  Health: "Bezpečnost",
  "Security health": "Bezpečnost trezoru",
  passwords: "hesel",
  weak: "slabých",
  reused: "opakovaných",
  bits: "bitů",
  "Scan all vaults": "Prohledat všechny trezory",
  "No weak or reused passwords found.": "Nenalezena žádná slabá ani opakovaná hesla.",
  "WEAK PASSWORDS": "SLABÁ HESLA",
  "REUSED PASSWORDS": "OPAKOVANÁ HESLA",
  "Used by": "Použito u",
  // Offline cache (M5.3, §15)
  Offline: "Offline",
  "Offline cache": "Offline mezipaměť",
  "Enable offline read-only cache on this device": "Povolit offline read-only cache na tomto zařízení",
  "Items marked “Allow offline” are cached automatically after you sign in, encrypted under a key protected by both your master password and this device's hardware, for 7 days. Unlock offline with the same master password; too many wrong attempts wipe the cache.":
    "Položky označené „Povolit offline“ se ukládají automaticky po přihlášení, šifrované klíčem chráněným zároveň vaším master heslem a hardwarem tohoto zařízení, na 7 dní. Offline je odemknete stejným master heslem; po příliš mnoha špatných pokusech se cache smaže.",
  "Rebuild now": "Obnovit nyní",
  "Offline cache refreshed.": "Offline cache obnovena.",
  Cached: "Uloženo",
  expired: "vypršelo",
  "No offline cache.": "Žádná offline cache.",
  "Wipe cache": "Smazat cache",
  // Desktop / launch
  "Launch SSH": "Spustit SSH",
  "Launch RDP": "Spustit RDP",
  "Open in mstsc": "Otevřít v mstsc",
  "RDP launch failed": "Spuštění RDP selhalo",
  "Connecting…": "Připojování…",
  "Session closed": "Relace ukončena",
  "Open in native client": "Otevřít v nativním klientovi",
  "Open this connection in the native OS client": "Otevřít toto připojení v nativním OS klientovi",
  "Couldn't connect with the embedded client": "Embedded klient se nepřipojil",
  "This gateway may require interactive sign-in (MFA / OTP). Open the native client to authenticate.":
    "Tato brána může vyžadovat interaktivní přihlášení (MFA / OTP). Pro ověření otevři nativního klienta.",
  "Use native RDP client": "Používat nativního RDP klienta",
  "Open RDP sessions in the native OS client instead of the in-app viewer. A per-item setting can override this.":
    "Otevírat RDP relace v nativním OS klientovi místo in-app prohlížeče. Nastavení u položky to může přebít.",
  // Desktop distribution + update
  "Download app": "Stáhnout aplikaci",
  "Download desktop app": "Stáhnout aplikaci pro desktop",
  "Download the desktop client straight from the platform — no GitHub needed.":
    "Stáhněte si desktopového klienta přímo z platformy — GitHub není potřeba.",
  "Downloads are not configured yet.": "Stahování zatím není nakonfigurováno.",
  "No builds available yet.": "Zatím nejsou k dispozici žádné sestavení.",
  "Release notes": "Poznámky k vydání",
  Download: "Stáhnout",
  "Downloading…": "Stahování…",
  "Loading…": "Načítání…",
  "A new version is available:": "Je dostupná nová verze:",
  "Downloaded — run it to update.": "Staženo — spusťte soubor pro aktualizaci.",
  "Show file": "Zobrazit soubor",
  Dismiss: "Zavřít",
  // Export (W5)
  Export: "Exportovat",
  "Export vault": "Exportovat trezor",
  "Export failed": "Export se nezdařil",
  "This file contains all secrets in plaintext. Store it securely and delete it when done. The export is audited.":
    "Tento soubor obsahuje všechna tajemství v čitelné podobě. Ulož ho bezpečně a po použití smaž. Export je auditován.",
  Format: "Formát",
  "JSON (full fidelity)": "JSON (úplný)",
  "CSV (spreadsheet)": "CSV (tabulka)",
  items: "položek",
  // Import (W5)
  "Import from a CSV (KeePass/Bitwarden columns) or a KeePass .kdbx database. Parsing and encryption happen in your browser.":
    "Import z CSV (sloupce KeePass/Bitwarden) nebo z databáze KeePass .kdbx. Parsování i šifrování probíhá ve tvém prohlížeči.",
  "Import from a CSV (KeePass/Bitwarden columns), a KeePass .kdbx database, or a Devolutions RDM .json export. Parsing and encryption happen in your browser.":
    "Import z CSV (sloupce KeePass/Bitwarden), z databáze KeePass .kdbx nebo z exportu Devolutions RDM .json. Parsování i šifrování probíhá ve tvém prohlížeči.",
  "Could not read this RDM export (expected a Devolutions RDM .json).": "Nepodařilo se načíst tento RDM export (očekává se Devolutions RDM .json).",
  "Could not read the credentials CSV.": "Nepodařilo se načíst CSV s přihlašovacími údaji.",
  "Optional: add the RDM CSV export (with credentials) to fill in usernames/passwords.":
    "Volitelné: přidej CSV export z RDM (s přihlašovacími údaji) pro doplnění jmen/hesel.",
  "Credentials matched": "Spárováno přihlašovacích údajů",
  folders: "složek",
  devices: "zařízení",
  "access methods": "přístupů",
  "Open database": "Otevřít databázi",
  "ready to import": "připraveno k importu",
  Imported: "Naimportováno",
  "No rows found (need a header row with a name/title column).": "Nenalezeny žádné řádky (je potřeba hlavička se sloupcem name/title).",
  "Could not read the file": "Soubor se nepodařilo načíst",
  "No entries found in this database.": "V této databázi nejsou žádné záznamy.",
  "Could not open the database — wrong password or unsupported format.": "Databázi se nepodařilo otevřít — špatné heslo nebo nepodporovaný formát.",
  // Auth / unlock
  "Sign in to your workspace": "Přihlaste se do svého prostředí",
  Login: "Přihlášení",
  Password: "Heslo",
  "2FA code (if enabled)": "2FA kód (je-li zapnuto)",
  "Sign in": "Přihlásit se",
  "Signing in…": "Přihlašuji…",
  or: "nebo",
  "Sign in with Microsoft Entra": "Přihlásit přes Microsoft Entra",
  "Sign-in failed": "Přihlášení selhalo",
  "Set your master password": "Nastavte hlavní heslo",
  "Unlock your vault": "Odemkněte trezor",
  "Master password": "Hlavní heslo",
  Confirm: "Potvrzení",
  "Create vault": "Vytvořit trezor",
  Unlock: "Odemknout",
  "Working…": "Pracuji…",
  "Wrong master password": "Špatné hlavní heslo",
  "Use a different account → sign out": "Použít jiný účet → odhlásit",
  Loading: "Načítání",
  Retry: "Zkusit znovu",
  "Sign out": "Odhlásit",
  "Cannot reach the server. Check your connection and retry.": "Server není dostupný. Zkontroluj připojení a zkus znovu.",

  // Shell / toolbar
  "New item": "Nová položka",
  "New folder": "Nová složka",
  "New device": "Nové zařízení",
  New: "Nový",
  "Vault menu": "Nabídka trezoru",
  Actions: "Akce",
  "Move to…": "Přesunout do…",
  Move: "Přesunout",
  "item(s)": "položek",
  "Move this item to trash?": "Přesunout položku do koše?",
  Open: "Otevřít",
  "New item here": "Nová položka zde",
  "New folder here": "Nová složka zde",
  "New device here": "Nové zařízení zde",
  "Add here": "Přidat zde",
  Rename: "Přejmenovat",
  Create: "Vytvořit",
  selected: "vybráno",
  Clear: "Zrušit výběr",
  "drag onto a folder/device, or": "přetáhni na složku/zařízení, nebo",
  Settings: "Nastavení",
  "Vault defaults": "Výchozí nastavení trezoru",
  "New items allowed in offline cache by default": "Nové položky ve výchozím stavu povoleny v offline cache",
  "New items default to being available in the device offline cache (§15). Existing items are unchanged.":
    "Nové položky budou ve výchozím stavu dostupné v offline cache zařízení (§15). Stávající položky se nemění.",
  "New folder name:": "Název nové složky:",
  "Device name:": "Název zařízení:",
  Category: "Kategorie",
  "Address / hostname (optional):": "Adresa / hostname (volitelné):",
  Edit: "Upravit",
  Duplicate: "Duplikovat",
  Delete: "Smazat",
  Import: "Import",
  Share: "Sdílet",
  "Share once…": "Sdílet jednorázově…",
  "New one-time share": "Nové jednorázové sdílení",
  "One-time link, shown once then destroyed": "Jednorázový odkaz — zobrazí se jednou, pak se zničí",
  History: "Historie",
  Trash: "Koš",
  Admin: "Správa",
  Vault: "Trezor",
  Lock: "Zamknout",

  // Navigator / grid
  VAULTS: "TREZORY",
  "Shared with me": "Sdíleno se mnou",
  "No vaults yet. Click ＋ to create one.": "Zatím žádné trezory. Klikni na ＋ pro vytvoření.",
  "Select a vault": "Vyber trezor",
  "Choose a vault on the left.": "Vyber trezor vlevo.",
  "Nothing shared with you.": "Nic ti není nasdíleno.",
  "Trash is empty.": "Koš je prázdný.",
  "No items. Use “New item”.": "Žádné položky. Použij „Nová položka“.",
  Name: "Název",
  Type: "Typ",
  "Host / URL": "Host / URL",
  Username: "Uživatel",
  Rev: "Rev",
  All: "Vše",

  // Detail
  PROPERTIES: "VLASTNOSTI",
  "No selection.": "Nic nevybráno.",
  "Restore from trash": "Obnovit z koše",
  Favorite: "Oblíbené",
  "★ Favorite": "★ Oblíbené",
  "☆ Favorite": "☆ Oblíbené",
  "(root)": "(kořen)",
  Tags: "Štítky",
  Notes: "Poznámky",
  reveal: "zobrazit",
  hide: "skrýt",
  copy: "kopírovat",
  ATTACHMENTS: "PŘÍLOHY",
  "+ Upload": "+ Nahrát",
  "No attachments.": "Žádné přílohy.",
  get: "stáhnout",
  del: "smazat",

  // Status bar
  Connected: "Připojeno",
  offline: "offline",
  "Vault unlocked": "Trezor odemčen",

  // Common dialog
  Cancel: "Zrušit",
  Save: "Uložit",
  "Saving…": "Ukládám…",
  Close: "Zavřít",

  // Toast feedback + workspace polish (UX foundation)
  copied: "zkopírováno",
  Saved: "Uloženo",
  "Item duplicated": "Položka zduplikována",
  "Moved to trash": "Přesunuto do koše",
  "Item restored": "Položka obnovena",
  "Import complete": "Import dokončen",
  failed: "selhalo",
  "Vault crypto runs in your browser": "Šifrování trezoru běží ve tvém prohlížeči",
  "Switch language": "Přepnout jazyk",
  "Keyboard shortcuts": "Klávesové zkratky",
  "Show sidebar": "Zobrazit postranní panel",
  "Hide sidebar": "Skrýt postranní panel",
  "Focus search": "Přejít na hledání",
  "Copy username": "Kopírovat uživatele",
  "Copy password": "Kopírovat heslo",
  "Toggle sidebar": "Přepnout postranní panel",

  // Session tabs + quick-connect (phase 2)
  "Quick connect": "Rychlé připojení",
  Connect: "Připojit",
  Host: "Host",
  Domain: "Doména",
  "This session runs in the desktop app": "Tato relace běží v desktopové aplikaci",
  "Embedded SSH sessions are available only in the desktop client.": "Vestavěné SSH relace jsou dostupné jen v desktopovém klientovi.",
  "Embedded RDP sessions are available only in the desktop client.": "Vestavěné RDP relace jsou dostupné jen v desktopovém klientovi.",

  // Search & organize (phase 3)
  Modified: "Změněno",
  "Any time": "Kdykoli",
  "Last 24 hours": "Posledních 24 hodin",
  "Last 7 days": "Posledních 7 dní",
  "Last 30 days": "Posledních 30 dní",
  "No items": "Žádné položky",
  "No tags": "Žádné štítky",
  "No saved searches": "Žádná uložená hledání",
  "Clear filters": "Zrušit filtry",
  "Save current search": "Uložit aktuální hledání",
  "Name this search": "Pojmenovat hledání",
  "Bulk edit": "Hromadná editace",
  "Bulk edit applied": "Hromadná editace provedena",
  "Add tags (comma-separated)": "Přidat štítky (oddělené čárkou)",
  "Remove tags (comma-separated)": "Odebrat štítky (oddělené čárkou)",
  "Move to folder": "Přesunout do složky",
  "(don't move)": "(nepřesouvat)",
  "Leave unchanged": "Ponechat beze změny",
  "Enable offline cache": "Zapnout offline mezipaměť",
  "Disable offline cache": "Vypnout offline mezipaměť",
  "Apply to": "Použít na",
  "Save as template": "Uložit jako šablonu",
  "Template name": "Název šablony",
  "Template saved": "Šablona uložena",
  "Delete template": "Smazat šablonu",
  "Delete this template?": "Smazat tuto šablonu?",
  "Save failed": "Uložení selhalo",

  // Dashboard + command palette (phase 4)
  Dashboard: "Přehled",
  Recent: "Nedávné",
  Favorites: "Oblíbené",
  Review: "Zobrazit",
  vaults: "trezorů",
  "Nothing recent yet.": "Zatím nic nedávného.",
  "No favorites yet.": "Zatím žádné oblíbené.",
  "Command palette": "Paleta příkazů",
  "Type a command or search…": "Zadejte příkaz nebo hledejte…",
  "No results": "Žádné výsledky",
  navigate: "pohyb",
  run: "spustit",
  close: "zavřít",
  Item: "Položka",
  Action: "Akce",
  "Go to": "Přejít na",
  Show: "Zobrazit",

  // Settings & preferences (phase 5)
  General: "Obecné",
  Security: "Zabezpečení",
  About: "O aplikaci",
  Language: "Jazyk",
  "Interface language.": "Jazyk rozhraní.",
  "Auto-lock after": "Automatický zámek po",
  "Lock the vault after this many minutes of inactivity (1–240).": "Zamknout trezor po tomto počtu minut nečinnosti (1–240).",
  min: "min",
  "Clear clipboard after": "Vymazat schránku po",
  "Wipe copied secrets from the clipboard after this many seconds (5–600).": "Vymazat zkopírovaná tajemství ze schránky po tomto počtu sekund (5–600).",
  Application: "Aplikace",
  Platform: "Platforma",
  Desktop: "Desktop",
  Web: "Web",
  "App version": "Verze aplikace",
  "Crypto format": "Formát šifrování",
  "End-to-end encrypted. Secrets are decrypted only in your browser (§4).": "Šifrováno end-to-end. Tajemství se dešifrují jen ve vašem prohlížeči (§4).",
  "Settings saved": "Nastavení uloženo",
  BRANDING: "BRANDING",
  "Vault display name": "Zobrazovaný název trezoru",
  Remove: "Odebrat",
  "Shown in the header for everyone in this vault. Non-secret.": "Zobrazí se v záhlaví všem v tomto trezoru. Není tajné.",
  "Logo must be under 200 KB.": "Logo musí být menší než 200 KB.",

  // Offline cache location (v0.4.1)
  "Cache location": "Umístění mezipaměti",
  "Change…": "Změnit…",
  "Reset to default": "Obnovit výchozí",
  "Cache location changed — it will repopulate on the next unlock or rebuild.":
    "Umístění mezipaměti změněno — naplní se při příštím odemknutí nebo obnovení.",

  // Offline mode (v0.6.0)
  "Continue offline": "Pokračovat offline",
  "Offline mode — server unreachable": "Offline režim — server nedostupný",
  "Read-only access to your cached items.": "Přístup jen pro čtení k uloženým položkám.",
  "No offline data available — connect to the server.": "Žádná offline data — připojte se k serveru.",
  "Unlock offline": "Odemknout offline",
  "Retry connection": "Zkusit připojení znovu",
  "Offline — read only. Showing your cached items; launch uses saved credentials.":
    "Offline — jen pro čtení. Zobrazují se uložené položky; spuštění používá uložené přihlašovací údaje.",
  "Connection lost — working from memory. Changes are disabled until you reconnect.":
    "Spojení ztraceno — pracuje se z paměti. Změny jsou vypnuté, dokud se znovu nepřipojíte.",
  "Read-only": "Jen pro čtení",
  "Available in the desktop offline cache (§15). On by default.":
    "Dostupné v offline mezipaměti desktopu (§15). Ve výchozím stavu zapnuto.",

  // Change master password (§7.2)
  "Change master password": "Změnit master heslo",
  "Re-encrypts your vault keys under a new password. It is never sent to the server and cannot be recovered.":
    "Znovu zašifruje klíče trezoru novým heslem. Heslo se nikdy neposílá na server a nelze ho obnovit.",
  "Current password": "Současné heslo",
  "New password": "Nové heslo",
  "Confirm new password": "Potvrdit nové heslo",
  "At least": "Alespoň",
  "characters.": "znaků.",
  "Passwords do not match.": "Hesla se neshodují.",
  "New password must differ from the current one.": "Nové heslo se musí lišit od současného.",
  "Master password changed.": "Master heslo změněno.",
  "Change password": "Změnit heslo",

  // Desktop app settings
  "Start maximized": "Spouštět maximalizované",
  "Open the window maximized on every launch.": "Otevřít okno maximalizované při každém spuštění.",
  "Minimize to tray on close": "Zavřením minimalizovat do lišty",
  "Closing the window hides it to the system tray and keeps the app running.":
    "Zavření okna ho skryje do systémové lišty a aplikace běží dál.",
  "Restore open tabs": "Obnovit otevřené záložky",
  "Reopen the tabs you had open, after the vault unlocks on next launch.":
    "Po odemčení trezoru při dalším spuštění znovu otevře dříve otevřené záložky.",
  "Window size & position are remembered automatically.":
    "Velikost a pozice okna se pamatují automaticky.",

  // Login — SSO primary, password backup
  "Sign in with Microsoft 365": "Přihlásit přes Microsoft 365",
  "Use your work account.": "Použijte svůj pracovní účet.",
  "Sign in with name and password instead": "Přihlásit jménem a heslem",
  "Backup sign-in": "Záložní přihlášení",

  // Browser extension (MV3) — popup/options/onboarding
  "Zero-knowledge — decryption happens on this device.": "Zero-knowledge — dešifrování probíhá na tomto zařízení.",
  "The session has expired. Open the vault — the extension reconnects automatically.": "Relace vypršela. Otevřete Vault — rozšíření se připojí automaticky.",
  "Connect the extension to your vault. Open the vault and sign in; pairing completes automatically.": "Propojte rozšíření se svým trezorem. Otevřete Vault a přihlaste se; párování proběhne automaticky.",
  "Open Vault and connect": "Otevřít Vault a propojit",
  "Sign in with password instead": "Přihlásit se raději heslem",
  "TOTP code": "TOTP kód",
  "Sign-in failed. Check your credentials and TOTP code.": "Přihlášení selhalo. Zkontrolujte údaje a TOTP kód.",
  "Unlocking…": "Odemykám…",
  "The master password never leaves this device.": "Hlavní heslo nikdy neopustí toto zařízení.",
  "Wrong master password.": "Nesprávné hlavní heslo.",
  "This account is not enrolled yet — open the vault first.": "Účet ještě není aktivovaný — nejdříve otevřete Vault.",
  "No personal vault exists yet — open the vault first.": "Osobní trezor ještě neexistuje — nejdříve otevřete Vault.",
  "Unlock failed.": "Odemčení selhalo.",
  "Browser folder": "Složka prohlížeče",
  "logins available": "přihlášení k dispozici",
  "No folder is bound yet — finish setup in the extension options.": "Zatím není svázaná žádná složka — dokončete nastavení v možnostech rozšíření.",
  "Vault — browser extension": "Vault — rozšíření prohlížeče",
  "Connect to the vault": "Připojení k trezoru",
  "Connected as": "Připojeno jako",
  "Unlock the vault": "Odemčení trezoru",
  "Unlocked.": "Odemčeno.",
  "Finish the previous step first.": "Nejdříve dokončete předchozí krok.",
  "Folder selection is part of the next build step.": "Výběr složky přijde v dalším kroku sestavení.",
  // Browser extension pairing (SPA side)
  Browser: "Prohlížeč",
  "The browser extension autofills and saves logins into your personal vault, taking over from the browser's built-in password manager.": "Rozšíření prohlížeče vyplňuje a ukládá přihlášení do vašeho osobního trezoru a přebírá roli vestavěného správce hesel prohlížeče.",
  "1. Install the extension": "1. Nainstalujte rozšíření",
  "Download extension": "Stáhnout rozšíření",
  "Managed devices receive it automatically via policy.": "Spravovaná zařízení ho dostanou automaticky přes zásady.",
  "2. Connect this session": "2. Propojte tuto relaci",
  "Connect browser extension": "Propojit rozšíření prohlížeče",
  "Connected ✓": "Propojeno ✓",
  "Could not connect the extension.": "Rozšíření se nepodařilo propojit.",
  "Open the extension and unlock it with your master password.": "Otevřete rozšíření a odemkněte ho hlavním heslem.",
  "Install the extension, then reload this page to connect it.": "Nainstalujte rozšíření a načtěte tuto stránku znovu, aby se propojilo.",
  // Browser extension — popup matches/generator + folder picker (F3)
  "Could not fill this page.": "Tuto stránku se nepodařilo vyplnit.",
  "Could not copy.": "Kopírování se nezdařilo.",
  "Username copied.": "Uživatelské jméno zkopírováno.",
  "Password copied — clears shortly.": "Heslo zkopírováno — brzy se vymaže.",
  "No matches.": "Žádné shody.",
  "No saved logins for this site.": "Pro tento web nejsou uložená přihlášení.",
  "Saved over https": "Uloženo přes https",
  Fill: "Vyplnit",
  "Open setup": "Otevřít nastavení",
  Logins: "Přihlášení",
  Generate: "Generovat",
  "Search all logins…": "Hledat ve všech přihlášeních…",
  Regenerate: "Přegenerovat",
  Copy: "Kopírovat",
  Length: "Délka",
  "Bound to": "Svázáno se složkou",
  "Change folder": "Změnit složku",
  "Create a new folder": "Vytvořit novou složku",
  "Create & bind": "Vytvořit a svázat",
  "…or pick an existing folder": "…nebo vyberte existující složku",
  "No folders in your personal vault yet.": "V osobním trezoru zatím nejsou žádné složky.",
  Bind: "Svázat",
  "Unlock the vault first.": "Nejdříve odemkněte trezor.",
  // Browser extension — context menu (F4)
  "Vault: fill login": "Vault: vyplnit přihlášení",
  // Browser extension — save/update bar (F5)
  "Save this login to Vault?": "Uložit toto přihlášení do Vaultu?",
  "Update the saved password?": "Aktualizovat uložené heslo?",
  "Never here": "Zde nikdy",
  "Not now": "Teď ne",
  Update: "Aktualizovat",
  // Browser extension — CSV import (F6)
  "Bind a folder first (step 3).": "Nejdříve svažte složku (krok 3).",
  "Export your passwords from chrome://password-manager (Settings → Export) or edge://wallet, then import the CSV here. Duplicates are skipped.": "Vyexportujte hesla z chrome://password-manager (Nastavení → Export) nebo edge://wallet a naimportujte CSV zde. Duplicity se přeskočí.",
  "No logins found in this CSV (need a header row with a name/url column).": "V tomto CSV nejsou žádná přihlášení (je potřeba hlavička se sloupcem name/url).",
  "Choose CSV file": "Vybrat CSV soubor",
  "logins ready to import": "přihlášení připraveno k importu",
  "Import into vault": "Naimportovat do trezoru",
  "Importing…": "Importuji…",
  skipped: "přeskočeno",
  "Now delete the passwords from the browser's built-in manager so it stops offering them, and turn off its saving (next section).": "Nyní smažte hesla z vestavěného správce prohlížeče, aby je přestal nabízet, a vypněte jeho ukládání (další sekce).",
  "Import another file": "Naimportovat další soubor",
  "Import from the browser": "Import z prohlížeče",
  // Browser extension — take-over (F7)
  "Take over password saving": "Převzít ukládání hesel",
  "Turn off the browser's own password saving so it stops competing with Vault. On managed devices this is enforced by policy.": "Vypněte vlastní ukládání hesel prohlížeče, aby nekonkurovalo Vaultu. Na spravovaných zařízeních to vynucuje zásada.",
  "Password saving is already disabled by device policy.": "Ukládání hesel je již vypnuto zásadou zařízení.",
  "The browser's built-in saving is off. ✓": "Vestavěné ukládání prohlížeče je vypnuto. ✓",
  "Turn off browser password saving": "Vypnout ukládání hesel v prohlížeči",
  // Browser extension — Settings guide (návod)
  "Extension detected in this browser. ✓": "Rozšíření v tomto prohlížeči nalezeno. ✓",
  "Extension not detected yet — install it, then reload this page.": "Rozšíření zatím nenalezeno — nainstalujte ho a načtěte tuto stránku znovu.",
  "Install the extension": "Nainstalujte rozšíření",
  "On company-managed devices the extension installs automatically via policy — just wait for it to appear, then continue below.": "Na firemně spravovaných zařízeních se rozšíření nainstaluje automaticky přes zásadu — počkejte, až se objeví, a pokračujte níže.",
  "Download extension (.crx)": "Stáhnout rozšíření (.crx)",
  "Reload page": "Načíst stránku znovu",
  "Extension ID": "ID rozšíření",
  "Manual install (for testing on an unmanaged device)": "Ruční instalace (pro testování na nespravovaném zařízení)",
  "Open chrome://extensions (or edge://extensions).": "Otevřete chrome://extensions (nebo edge://extensions).",
  "Turn on Developer mode (top-right).": "Zapněte Režim pro vývojáře (vpravo nahoře).",
  "Click “Load unpacked” and select the extension folder your admin provides.": "Klikněte na „Načíst rozbalené“ a vyberte složku rozšíření, kterou vám poskytne správce.",
  "A downloaded .crx can only be installed by company policy, not by drag-and-drop — ask IT if unsure.": "Stažený .crx lze nainstalovat pouze firemní zásadou, ne přetažením — v případě nejistoty se obraťte na IT.",
  "Connect this session": "Propojte tuto relaci",
  "This links the extension to your account. Microsoft 365 users never type a password here — the connection reuses this session.": "Tím se rozšíření prováže s vaším účtem. Uživatelé Microsoft 365 zde heslo nezadávají — propojení využije tuto relaci.",
  "Sessions last 12 hours; the extension reconnects automatically each time you open the vault.": "Relace trvají 12 hodin; rozšíření se automaticky znovu propojí při každém otevření trezoru.",
  "Install the extension first (step 1), then reload this page.": "Nejdříve nainstalujte rozšíření (krok 1) a načtěte tuto stránku znovu.",
  "Finish setup in the extension": "Dokončete nastavení v rozšíření",
  "Click the Vault icon in the browser toolbar (pin it for easy access), then:": "Klikněte na ikonu Vault na liště prohlížeče (připněte si ji pro snadný přístup) a pak:",
  "Unlock with your master password — it never leaves your device.": "Odemkněte hlavním heslem — nikdy neopustí vaše zařízení.",
  "Choose or create the personal-vault folder the browser will use.": "Vyberte nebo vytvořte složku osobního trezoru, kterou bude prohlížeč používat.",
  "Optionally import your existing passwords from a CSV export.": "Volitelně naimportujte stávající hesla z exportu CSV.",
  "Turn off the browser's built-in password saving so it stops competing.": "Vypněte vestavěné ukládání hesel v prohlížeči, aby již nekonkurovalo.",
  // Browser extension — ZIP unpacked install
  "On company-managed devices the extension installs automatically via policy — just wait for it to appear, then continue below. On other devices, use the ZIP + “Load unpacked” below.": "Na firemně spravovaných zařízeních se rozšíření nainstaluje automaticky přes zásadu — počkejte, až se objeví, a pokračujte níže. Na ostatních zařízeních použijte ZIP + „Načíst rozbalené“ níže.",
  "Download extension (.zip)": "Stáhnout rozšíření (.zip)",
  ".crx (for policy)": ".crx (pro zásadu)",
  "Manual install with the ZIP (Chrome / Edge)": "Ruční instalace přes ZIP (Chrome / Edge)",
  "Download the .zip above and extract it to a permanent folder (don't delete it — the browser loads the extension from there).": "Stáhněte .zip výše a rozbalte ho do trvalé složky (nemažte ji — prohlížeč z ní rozšíření načítá).",
  "Open edge://extensions (or chrome://extensions).": "Otevřete edge://extensions (nebo chrome://extensions).",
  "Turn on Developer mode (left side on Edge, top-right on Chrome).": "Zapněte Režim pro vývojáře (v Edge vlevo, v Chrome vpravo nahoře).",
  "Click “Load unpacked” and select the extracted folder (the one containing manifest.json).": "Klikněte na „Načíst rozbalené“ a vyberte rozbalenou složku (tu, která obsahuje manifest.json).",
  "Reload this page and click Connect below.": "Načtěte tuto stránku znovu a klikněte na Propojit níže.",
  "The .crx file is only for automated policy install — Chrome/Edge block installing it by drag-and-drop.": "Soubor .crx slouží jen pro automatickou instalaci přes zásadu — Chrome/Edge jeho instalaci přetažením blokují.",
  // Browser extension — unlock diagnostics
  "The vault re-locked — please try again.": "Trezor se znovu zamkl — zkuste to prosím znovu.",
  "Can't reach the vault server.": "Nelze se spojit se serverem trezoru.",
  "Session expired — reconnect the extension in the vault (Settings → Browser), then unlock again.": "Relace vypršela — propojte rozšíření znovu ve vaultu (Nastavení → Prohlížeč) a poté odemkněte znovu.",
  // Browser extension — lock reasons
  "Locked because the session expired — reconnect in the vault (Settings → Browser).": "Zamčeno, protože vypršela relace — propojte znovu ve vaultu (Nastavení → Prohlížeč).",
  "Locked because the computer was locked.": "Zamčeno, protože byl uzamčen počítač.",
  "Locked after 15 minutes of inactivity.": "Zamčeno po 15 minutách nečinnosti.",
  "Signed out.": "Odhlášeno.",
  // Item editor — unsaved-work protection
  "Edit item": "Upravit položku",
  Unsaved: "Neuloženo",
  "Name is required": "Název je povinný",
  "Could not load item": "Položku se nepodařilo načíst",
  "Discard unsaved changes?": "Zahodit neuložené změny?",
  "Item was modified elsewhere and the conflict copy failed — reopen and retry.":
    "Položka byla mezitím změněna jinde a kopii konfliktu se nepodařilo uložit — otevři znovu a zkus to znovu.",
  "Your session expired — sign in again. This item is kept and can be restored.":
    "Relace vypršela — přihlas se znovu. Rozepsaná položka zůstává zachovaná a půjde obnovit.",
  "Your session expired — please sign in again. Your unsaved item is kept.":
    "Relace vypršela — přihlas se prosím znovu. Rozepsaná položka zůstává zachovaná.",
  "An unsaved item was not stored": "Rozepsaná položka nebyla uložena",
  Restore: "Obnovit",
  Discard: "Zahodit",
  "Lock hidden tab after": "Zamknout skrytou záložku po",
  "Grace period before switching away from this tab locks the vault (0–300 s; 0 locks immediately).":
    "Prodleva, než přepnutí pryč z této záložky zamkne trezor (0–300 s; 0 zamkne okamžitě).",
  // Item editor — catalog type + field labels (translated at render; the stored field KEY never is)
  Website: "Web",
  "Network device": "Síťový prvek",
  Database: "Databáze",
  "API key": "API klíč",
  Certificate: "Certifikát",
  "Secure note": "Zabezpečená poznámka",
  Generic: "Obecné",
  Port: "Port",
  "Auth method": "Způsob přihlášení",
  "Private key": "Privátní klíč",
  "Public key": "Veřejný klíč",
  "Key passphrase": "Heslo ke klíči",
  Passphrase: "Heslo (fráze)",
  "Host key fingerprint": "Otisk host key",
  "Jump host": "Jump host",
  "Escalation (sudo/su)": "Eskalace (sudo/su)",
  Connector: "Konektor",
  "Gateway address": "Adresa gateway",
  "Gateway credentials": "Přihlášení ke gateway",
  "Gateway username": "Uživatel gateway",
  "Gateway password": "Heslo gateway",
  "RDP client": "RDP klient",
  "VPN type": "Typ VPN",
  "Server address": "Adresa serveru",
  "Mgmt address": "Adresa správy",
  "Mgmt URL": "URL správy",
  "Enable password": "Enable heslo",
  Engine: "Databázový stroj",
  "Connection string": "Připojovací řetězec",
  "Endpoint URL": "URL endpointu",
  "Key ID": "ID klíče",
  Secret: "Tajemství",
  Token: "Token",
  Scopes: "Scopes",
  Expires: "Platnost do",
  "CA chain": "CA řetěz",
  Fingerprint: "Otisk",
  SSID: "SSID",
  Body: "Text",
  "OTP recovery codes": "Záložní OTP kódy",
  // Item editor — layout, sections, validation
  Details: "Údaje",
  Credentials: "Přihlášení",
  Advanced: "Pokročilé",
  "Custom fields": "Vlastní pole",
  "Notes and tags": "Poznámky a štítky",
  "Add custom field": "Přidat vlastní pole",
  "Save into": "Uložit do",
  "Field name": "Název pole",
  "Field type": "Typ pole",
  "Clear value": "Vymazat hodnotu",
  "Remove field": "Odebrat pole",
  "Add a note": "Přidat poznámku",
  "note for this field": "poznámka k tomuto poli",
  Reveal: "Zobrazit",
  Hide: "Skrýt",
  "Changing the type clears these fields:": "Změna typu vymaže tato pole:",
  "field(s) need attention": "polí potřebuje opravit",
  "Port must be a number": "Port musí být číslo",
  "Port must be between 1 and 65535": "Port musí být mezi 1 a 65535",
  "This does not look like a valid URL": "Tohle nevypadá jako platná URL",
  "Without an address this item cannot be launched": "Bez adresy nepůjde položku spustit",
  "add a tag…": "přidat štítek…",
  "Generate…": "Vygenerovat…",
  Use: "Použít",
  len: "délka",
  words: "slov",
  "bits of entropy": "bitů entropie",
  passphrase: "fráze",
  // Item editor — unsaved-work protection
  "Choose the personal-vault folder the browser will use:": "Vyberte složku osobního trezoru, kterou bude prohlížeč používat:",
  "More options (import, take over saving)…": "Další možnosti (import, převzetí ukládání)…",
};
